import type { ContentChangeListener } from '@volkswagen-onehub/audi-content-service';

type ContentStore = Record<string, any>;

export class MockContentServiceV1 {
  private consumerId: string;

  private store: ContentStore;

  private listeners: Set<ContentChangeListener>;

  constructor(consumerId = 'mock-consumer', initialContent: any = {}) {
    this.consumerId = consumerId;
    this.store = initialContent;
    this.listeners = new Set();
  }

  getContent(): any {
    return this.store;
  }

  setContent(newContent: any): void {
    this.store = newContent;
    this.listeners.forEach((listener) => listener());
  }

  onContentChange(listener: ContentChangeListener): void {
    this.listeners.add(listener);
  }

  removeOnContentChange(listener: ContentChangeListener): void {
    this.listeners.delete(listener);
  }
}

// DEFAULT MOCK CONTENT
export const MOCK_AEM_CONTENT = {
  __type: 'aem-headless',
  contentPath: '/content/dam/oadd/us/02c07/en/inventory/new/fa-vlp-list-page',
  fields: {
    vendorCtaGroup: {
      contentPath: '/content/dam/oadd/us/02c07/en/configurations/inventory/fa-vlp-list-page-cta',
      fields: {
        singlePositionVendorCTAs: [
          {
            contentPath:
              '/content/dam/oadd/us/02c07/en/configurations/inventory/fa-vlp-list-page-cta-upstart',
            fields: {
              isVendorCtaEnabled: true,
              configTypeLocationUpstart: 'srp',
            },
            model: {
              path: '/conf/feature-apps/oneaudi-feature-app-vlp-list-page/latest/settings/dam/cfm/models/vendor-cta-upstart',
              title: 'Vendor CTA - Upstart',
            },
          },
        ],
      },
      model: {
        path: '/conf/feature-apps/oneaudi-feature-app-vlp-list-page/latest/settings/dam/cfm/models/vendor-ctas-singlepositions',
        title: 'Vendor CTAs Single Positions',
      },
    },
    priceBreakdownGroup: {
      contentPath:
        '/content/dam/oadd/us/02c07/en/configurations/inventory/fa-vlp-list-page-price-breakdown',
      fields: {
        displayRebates: true,
        isFinalPriceEnabled: true,
        finalPriceLabel: 'Audi Richfield Price',
        isRetailEnabledUsed: 'true',
        usedRetailLabel: 'Price',
        mainPriceKey: 'regular',
        isRegularPricingEnabled: true,
        regularPricingLabel: 'Total MSRP',
        regularPricingShortDisclaimer: 'Dealer Sets Actual Price',
        regularPricingLongDisclaimer:
          'Total MSRP includes destination of $1295. Total MSRP excludes taxes, title, other options, and dealer charges and fees. Dealer sets actual price. May vary from MSRP.',
        hasTextOverrideRegular: 'true',
        isDealerDiscountEnabled: true,
        dealerDiscountLabel: 'Dealer Discount',
        isOEMDiscountEnabled: false,
        isDealerMarkupEnabled: false,
        isNonConditionalBonusEnabled: false,
        isDealerPriceEnabled: false,
        isDealerDocFeesEnabled: false,
        isDestinationAndHandlingFeesEnabled: false,
        isRetailEnabled: false,
        displayRebatesUsed: false,
        negativePricesNew: [],
        negativePricesUsed: [],
      },
      model: {
        path: '/conf/feature-apps/oneaudi-feature-app-vlp-list-page/latest/settings/dam/cfm/models/us-price-breakdown',
        title: 'US Price Breakdown',
      },
    },
  },
  model: {
    metadata: {
      baseUrl: 'https://fa-vlp-list-page.cdn.prod.collab.apps.one.audi/v5.16.0',
      id: 'f7c4f635-ec1a-4b4c-bf14-881d4ab39014',
      src: 'fh/app.js',
      config: '',
    },
    path: '/conf/feature-apps/oneaudi-feature-app-vlp-list-page/latest/settings/dam/cfm/models/fa-vlp-list-page',
    title: 'fa-vlp-list-page',
  },
};

export const createMockContentService = () =>
  new MockContentServiceV1('mock-consumer', MOCK_AEM_CONTENT);
